import React, { FC } from 'react';

import { PopoverMenu, SelectorButton } from '@gem/ui-kit';

import { useCalendarViewMenuPresenter } from './CalendarViewMenu.presenter';
import { ICalendarViewMenuProps } from './CalendarViewMenu.types';

export const CalendarViewMenu: FC<ICalendarViewMenuProps> = (props) => {
  const { menuClassName, placement, ...rest } = props;
  const { presenter, buttonRef } = useCalendarViewMenuPresenter(rest);

  return (
    <>
      <SelectorButton
        setRef={buttonRef}
        onClick={presenter.toggleIsOpened}
        isActive={presenter.isOpened}
        title={presenter.buttonLabel}
        Icon={presenter.buttonIcon}
        theme="without-background"
        dataTest="calendar-view-select-button"
      />
      <PopoverMenu
        className={menuClassName}
        isOpened={presenter.isOpened}
        menuItems={presenter.menuItems}
        onClose={presenter.onClose}
        reference={buttonRef.current}
        placement={placement}
        modifiers={[
          {
            name: 'offset',
            options: { offset: [0, 0] },
          },
        ]}
      />
    </>
  );
};
